import { createUnifiedTheme, genPageTheme, palettes } from '@backstage/theme';
import { tokens } from '@neo4j-ndl/base';

import { FALLBACK_FONT_STACK } from './const';

export const auraLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: tokens.theme.light.color.primary.text,
    },
    secondary: {
      main: tokens.theme.light.color.neutral.bg.strong,
    },
    error: {
      main: tokens.theme.light.color.danger.text,
    },
    warning: {
      main: tokens.theme.light.color.warning.text,
    },
    info: {
      main: tokens.theme.light.color.primary.text,
    },
    success: {
      main: tokens.theme.light.color.success.text,
    },
    background: {
      default: tokens.theme.light.color.neutral.bg.weak,
      paper: tokens.theme.light.color.neutral.bg.weak,
    },
    banner: {
      info: tokens.theme.light.color.primary.text,
      error: tokens.theme.light.color.danger.text,
      warning: tokens.theme.light.color.warning.bg.weak,
      text: tokens.theme.light.color.primary.text,
      link: tokens.theme.light.color.primary.text,
    },
    errorBackground: tokens.theme.light.color.danger.bg.weak,
    warningBackground: tokens.theme.light.color.warning.bg.weak,
    infoBackground: tokens.theme.light.color.primary.bg.weak,
    navigation: {
      background: tokens.theme.light.color.neutral.bg.default,
      indicator: tokens.theme.light.color.primary.text,
      color: tokens.theme.light.color.neutral.text.default,
      selectedColor: tokens.theme.light.color.primary.text,
      navItem: {
        hoverBackground: tokens.theme.light.color.neutral.hover,
      },
      submenu: {
        background: tokens.theme.light.color.neutral.bg.strong,
      },
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.75rem',
          '& a': {
            color: tokens.theme.dark.color.primary.text,
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardError: {
          backgroundColor: tokens.theme.light.color.danger.bg.weak,
          color: tokens.theme.light.color.danger.text,
          border: `1px solid ${tokens.theme.light.color.danger.border.strong}`,
        },
        standardWarning: {
          backgroundColor: tokens.theme.light.color.warning.bg.weak,
          color: tokens.theme.light.color.warning.text,
          border: `1px solid ${tokens.theme.light.color.warning.border.strong}`,
        },
        standardSuccess: {
          backgroundColor: tokens.theme.light.color.success.bg.weak,
          color: tokens.theme.light.color.success.text,
          border: `1px solid ${tokens.theme.light.color.success.border.strong}`,
        },
        standardInfo: {
          backgroundColor: tokens.theme.light.color.primary.bg.weak,
          color: tokens.theme.light.color.primary.text,
          border: `1px solid ${tokens.theme.light.color.primary.border.strong}`,
        },
        icon: {
          color: 'inherit',
        },
      },
    },
  },
  defaultPageTheme: 'home',
  fontFamily: `Nunito Sans, ${FALLBACK_FONT_STACK}`,
  /* below drives the header colors */
  pageTheme: {
    home: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    documentation: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    tool: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    service: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    website: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    library: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    other: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    app: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
    apis: genPageTheme({
      colors: [tokens.theme.light.color.primary.bg.strong],
      shape: 'none',
    }),
  },
});
